<div class="container">
  <div class="row center">
    <div class="col col-50 white">
      <img
        [src]="logoUrl"
      />
      <app-spinner [display]="true" [class]="'spinner-container'"></app-spinner>
    </div>
  </div>
</div>
